module.exports = __webpack_public_path__ + "static/img/Google_Books_logo.504c0bd4.png";